module.exports = __webpack_public_path__ + "e021e8ecdf31ea877a864b2cb48559f6.MP3";